import { render } from "./Modal.vue?vue&type=template&id=7c55d248"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=7c55d248&lang=scss"
script.render = render

export default script